export default "__VITE_ASSET__9d1d1ff1__"